import { Plugin, PluginKey } from "prosemirror-state";
import type { EditorView } from "prosemirror-view";

export const caretInTextKey = new PluginKey("diff-caret-in-text");

const lastText = (node: Node | null): Text | null => {
	let current = node;
	while (current && current.nodeType !== Node.TEXT_NODE) {
		if (current instanceof HTMLElement && current.isContentEditable === false) return null;
		current = current.lastChild;
	}
	return current as Text | null;
};

const samePosition = (view: EditorView, text: Text, head: number) => {
	try {
		return view.posAtDOM(text, text.length) === head;
	} catch {
		return false;
	}
};

const moveCaretIntoText = (view: EditorView) => {
	if (!view.hasFocus() || !view.state.selection.empty) return;
	const selection = view.dom.ownerDocument.getSelection();
	const anchor = selection?.anchorNode;
	if (!selection?.isCollapsed || !(anchor instanceof HTMLElement) || !view.dom.contains(anchor)) return;
	const text = lastText(anchor.childNodes[selection.anchorOffset - 1] ?? null);
	if (text && samePosition(view, text, view.state.selection.head)) selection.collapse(text, text.length);
};

const caretInText = () =>
	new Plugin({
		key: caretInTextKey,
		view: () => ({ update: moveCaretIntoText }),
	});

export default caretInText;
